var TokenSize;
(function (TokenSize) {
    TokenSize["LARGE"] = "large";
    TokenSize["NORMAL"] = "normal";
})(TokenSize || (TokenSize = {}));
var TokenShape;
(function (TokenShape) {
    TokenShape["CIRCLE"] = "circle";
    TokenShape["ROUNDED"] = "rounded";
    TokenShape["ROUNDED_WITH_BORDER"] = "rounded-with-border";
})(TokenShape || (TokenShape = {}));
export { TokenSize, TokenShape, };
//# sourceMappingURL=token-list-constants.js.map